@if (name) {
  <label class="header-label" for="clonedBasketItemName" i18n="@@parkingdetails_name">Name:</label>
  <input
    appInput
    [noIcon]="true"
    i18n-placeholder
    [placeholder]="name"
    [disabled]="true"
    id="clonedBasketItemName"
  />
}
@if (flightNumbers) {
  <label class="header-label" for="clonedBasketFlightNumber" i18n="@@filterFlightsFlightNumber"
    >Flight Number</label
  >
  <input
    appInput
    [noIcon]="true"
    i18n-placeholder
    [placeholder]="flightNumbers"
    [disabled]="true"
    id="clonedBasketFlightNumber"
  />
}
